import { compose } from 'redux';
import { connect } from 'react-redux';
import insurancePlanDecorator from 'insurance/insurancePlans/decorator';
import subscriptionDecorator from 'subscriptions/decorator';
import { getFilteredInsuranceContracts, getFilteredInsuredDevices, getInsuranceContractFetchStatus, getInsuredDeviceFetchStatus } from 'reducers';
import { fetchFiltered as fetchFilteredInsuranceContracts } from 'insurance/insuranceContracts/actions';
import { fetchFiltered as fetchFilteredInsuredDevices } from 'insurance/insuredDevices/actions';
import * as routes from 'app/routes';

import InsuranceInfo from './InsuranceInfo';

const mapStateToProps = (state, ownProps) => {
  const subId = ownProps.subId && parseInt(ownProps.subId);
  const filter = 'quickSubscription';
  const fetchContractStatus = getInsuranceContractFetchStatus(state);
  const fetchDeviceStatus = getInsuredDeviceFetchStatus(state);
  const contracts = getFilteredInsuranceContracts(state, { [filter]: subId });
  const contract = contracts && contracts.length > 0 && contracts.find(c => c.status === 'active');
  const insuredDevices = contract && getFilteredInsuredDevices(state, contract.id);
  const insuredDevice = insuredDevices && insuredDevices.length > 0 && insuredDevices.find(d => d.status === 'active');
  const insurancePlanId = insuredDevice && insuredDevice.plan;
  return {
    insurancePlanId,
    filter,
    contract,
    contractId: contract && contract.id,
    insuredDevice,
    fetchContractStatus,
    fetchDeviceStatus,
  }
};

const mapDispatchToProps = {
  fetchFilteredInsuranceContracts,
  fetchFilteredInsuredDevices,
  subRoute: routes.quickSubscription,
}

// this order is really important
export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  insurancePlanDecorator
)(InsuranceInfo);
